import React, { useState } from "react";
import logo from "../assets/images/Latestlogo.png";

import { NavLink } from "react-router-dom";
import IdleTimer from "./IdleTimer";
import SessionTimeoutDialog from "./SessionTimeoutDialog";
import { getUserPermissions } from "../utils/permissions";

import {
  IoIosArrowForward,
  IoIosArrowBack,
} from "react-icons/io";

function Sidebar() {
  const [showTimeoutDialog, setShowTimeoutDialog] = useState(false);
  const [collapsed, setCollapsed] = useState(false);

  const permissions = getUserPermissions();

  const handleIdle = () => {
    setShowTimeoutDialog(true);
  };

  const handleLogout = () => {
    setShowTimeoutDialog(false);
    localStorage.clear();

    alert("Session expired due to inactivity");

    window.location.href = "/login";
  };

  /* =========================================================
     MENU STYLE
     BIG FONT + NO SCROLL
  ========================================================= */
  const menuClass = ({ isActive }) => `
    group
    relative
    flex
    w-full
    min-h-[44px]
    items-center
    gap-3
    rounded-lg
    border
    ${collapsed ? "justify-center px-1" : "px-3 py-1"}
    overflow-hidden
    transition-all
    duration-200

    ${
      isActive
        ? `
          border-cyan-200
          bg-cyan-50
          text-[#07111f]
          shadow-[0_4px_12px_rgba(14,165,233,0.08)]
        `
        : `
          border-transparent
          text-[#07111f]
          hover:border-cyan-100
          hover:bg-slate-50
          hover:text-cyan-700
        `
    }
  `;

  return (
    <>
      {/* =====================================================
          IDLE TIMER
      ===================================================== */}
      <IdleTimer onTimeout={handleIdle} />

      {/* =====================================================
          SESSION TIMEOUT
      ===================================================== */}
      <SessionTimeoutDialog
        isOpen={showTimeoutDialog}
        onLogout={handleLogout}
      />

      {/* =====================================================
          SIDEBAR
      ===================================================== */}
      <aside
        className={`
          relative
          z-50
          hidden
          h-screen
          max-h-screen
          min-h-0
          shrink-0
          flex-col
          overflow-hidden
          border-r
          border-slate-200
          bg-white
          text-[#07111f]
          shadow-[6px_0_25px_rgba(0,0,0,0.06)]
          transition-all
          duration-300
          md:flex

          ${collapsed ? "w-[72px]" : "w-[285px]"}
        `}
      >
        {/* ===================================================
            HEADER
        =================================================== */}
        <div
          className="
            relative
            flex
            h-[78px]
            min-h-[78px]
            w-full
            shrink-0
            items-center
            justify-center
            border-b
            border-slate-200
            bg-white
          "
        >
          {/* Logo */}
          {!collapsed && (
            <div className="flex items-center justify-center">
              <img
                src={logo}
                alt="MIM"
                className="
                  h-[68px]
                  w-[150px]
                  object-contain
                "
              />
            </div>
          )}

          {/* Collapsed Logo */}
          {collapsed && (
            <div className="flex items-center justify-center">
              <img
                src={logo}
                alt="MIM"
                className="
                  h-[48px]
                  w-[48px]
                  object-contain
                "
              />
            </div>
          )}

          {/* Collapse Button */}
          <button
            type="button"
            onClick={() => setCollapsed(!collapsed)}
            aria-label="Toggle sidebar"
            className="
              absolute
              right-2
              top-2
              flex
              h-7
              w-7
              items-center
              justify-center
              rounded-full
              border
              border-slate-200
              bg-white
              text-[#07111f]
              shadow-sm
              transition-all
              hover:border-cyan-200
              hover:bg-cyan-50
              hover:text-cyan-600
            "
          >
            <span
              className="
                flex
                items-center
                justify-center
                text-base
                leading-none
              "
            >
              {collapsed ? (
                <IoIosArrowForward />
              ) : (
                <IoIosArrowBack />
              )}
            </span>
          </button>
        </div>

        {/* ===================================================
            CONTENT
            NO SCROLL
        =================================================== */}
        <div
          className="
            relative
            flex-1
            min-h-0
            overflow-hidden
            bg-white
            px-3
            py-2
          "
        >
          <nav className="space-y-2">

            {/* =================================================
                SMS SECTION
            ================================================= */}
            {permissions.sms && (
              <div>

                {/* SMS Heading */}
                {!collapsed && (
                  <div
                    className="
                      mb-1
                      flex
                      h-6
                      items-center
                      gap-2
                      px-1
                    "
                  >
                    <div
                      className="
                        h-5
                        w-1
                        shrink-0
                        rounded-full
                        bg-[#07111f]
                      "
                    />

                    <span
                      className="
                        text-[12px]
                        font-extrabold
                        uppercase
                        leading-none
                        tracking-[0.14em]
                        text-[#07111f]
                      "
                    >
                      SMS Pages
                    </span>
                  </div>
                )}

                <div className="space-y-1">

                  {/* Check Mobile Number */}
                  <NavLink
                    to="/number"
                    className={menuClass}
                    title={
                      collapsed
                        ? "Check Mobile Number"
                        : ""
                    }
                  >
                    <MenuIcon icon="📱" />

                    {!collapsed && (
                      <>
                        <span
                          className="
                            flex
                            min-w-0
                            flex-1
                            items-center
                            whitespace-nowrap
                            text-[15px]
                            font-semibold
                            leading-tight
                          "
                        >
                          Check Mobile Number
                        </span>

                        <ArrowIcon />
                      </>
                    )}
                  </NavLink>

                  {/* Template Wise Report */}
                  <NavLink
                    to="/template"
                    className={menuClass}
                    title={
                      collapsed
                        ? "Template Wise Report"
                        : ""
                    }
                  >
                    <MenuIcon icon="📄" />

                    {!collapsed && (
                      <>
                        <span
                          className="
                            flex
                            min-w-0
                            flex-1
                            items-center
                            whitespace-nowrap
                            text-[15px]
                            font-semibold
                            leading-tight
                          "
                        >
                          Template Wise Report
                        </span>

                        <ArrowIcon />
                      </>
                    )}
                  </NavLink>

                  {/* Traffic Summary */}
                  <NavLink
                    to="/traffic"
                    className={menuClass}
                    title={
                      collapsed
                        ? "Traffic Summary"
                        : ""
                    }
                  >
                    <MenuIcon icon="📊" />

                    {!collapsed && (
                      <>
                        <span
                          className="
                            flex
                            min-w-0
                            flex-1
                            items-center
                            whitespace-nowrap
                            text-[15px]
                            font-semibold
                            leading-tight
                          "
                        >
                          Traffic Summary
                        </span>

                        <ArrowIcon />
                      </>
                    )}
                  </NavLink>

                  {/* Failure Analysis */}
                  <NavLink
                    to="/failure"
                    className={menuClass}
                    title={
                      collapsed
                        ? "Failure Analysis"
                        : ""
                    }
                  >
                    <MenuIcon icon="⚠️" />

                    {!collapsed && (
                      <>
                        <span
                          className="
                            flex
                            min-w-0
                            flex-1
                            items-center
                            whitespace-nowrap
                            text-[15px]
                            font-semibold
                            leading-tight
                          "
                        >
                          Failure Analysis
                        </span>

                        <ArrowIcon />
                      </>
                    )}
                  </NavLink>

                </div>
              </div>
            )}

            {/* =================================================
                EMAIL SECTION
            ================================================= */}
            {permissions.email && (
              <div>

                {/* Email Heading */}
                {!collapsed && (
                  <div
                    className="
                      mb-1
                      flex
                      h-6
                      items-center
                      gap-2
                      px-1
                    "
                  >
                    <div
                      className="
                        h-5
                        w-1
                        shrink-0
                        rounded-full
                        bg-[#07111f]
                      "
                    />

                    <span
                      className="
                        text-[12px]
                        font-extrabold
                        uppercase
                        leading-none
                        tracking-[0.14em]
                        text-[#07111f]
                      "
                    >
                      Email Pages
                    </span>
                  </div>
                )}

                <div className="space-y-1">

                  {/* Email Monitoring */}
                  <NavLink
                    to="/email-monitoring"
                    className={menuClass}
                    title={
                      collapsed
                        ? "Email Monitoring"
                        : ""
                    }
                  >
                    <MenuIcon icon="✉️" />

                    {!collapsed && (
                      <>
                        <span
                          className="
                            flex
                            min-w-0
                            flex-1
                            items-center
                            whitespace-nowrap
                            text-[15px]
                            font-semibold
                            leading-tight
                          "
                        >
                          Email Monitoring
                        </span>

                        <ArrowIcon />
                      </>
                    )}
                  </NavLink>

                  {/* Email Subject Wise Summary */}
                  <NavLink
                    to="/emailSubjectWiseReport"
                    className={menuClass}
                    title={
                      collapsed
                        ? "Email Subject Wise Summary"
                        : ""
                    }
                  >
                    <MenuIcon icon="📑" />

                    {!collapsed && (
                      <>
                        <span
                          className="
                            flex
                            min-w-0
                            flex-1
                            items-center
                            whitespace-nowrap
                            text-[14px]
                            font-semibold
                            leading-tight
                          "
                        >
                          Email Subject Wise Summary
                        </span>

                        <ArrowIcon />
                      </>
                    )}
                  </NavLink>

                  {/* Email Summary */}
                  <NavLink
                    to="/emailSummary"
                    className={menuClass}
                    title={
                      collapsed
                        ? "Email Summary"
                        : ""
                    }
                  >
                    <MenuIcon icon="📈" />

                    {!collapsed && (
                      <>
                        <span
                          className="
                            flex
                            min-w-0
                            flex-1
                            items-center
                            whitespace-nowrap
                            text-[15px]
                            font-semibold
                            leading-tight
                          "
                        >
                          Email Summary
                        </span>

                        <ArrowIcon />
                      </>
                    )}
                  </NavLink>

                </div>
              </div>
            )}

          </nav>
        </div>

        {/* ===================================================
            FOOTER
        =================================================== */}
        <div
          className="
            relative
            flex
            min-h-[46px]
            shrink-0
            items-center
            justify-center
            border-t
            border-slate-200
            bg-white
            px-2
          "
        >
          {!collapsed ? (
            <div className="flex flex-col items-center justify-center">

              <p
                className="
                  text-[8px]
                  font-bold
                  uppercase
                  leading-none
                  tracking-[0.2em]
                  text-slate-400
                "
              >
                Powered By
              </p>

              <p
                className="
                  mt-1
                  text-[11px]
                  font-bold
                  leading-none
                  tracking-wide
                  text-[#07111f]
                "
              >
                MyInboxMedia
              </p>

            </div>
          ) : (
            <div
              className="
                h-2
                w-2
                rounded-full
                bg-[#07111f]
              "
            />
          )}
        </div>

      </aside>
    </>
  );
}

/* =========================================================
   MENU ICON
========================================================= */
function MenuIcon({ icon }) {
  return (
    <div
      className="
        flex
        h-[34px]
        w-[34px]
        shrink-0
        items-center
        justify-center
        rounded-lg
        border
        border-slate-200
        bg-slate-50
        text-[17px]
        leading-none
        transition-all
        duration-200
        group-hover:border-cyan-200
        group-hover:bg-cyan-50
      "
    >
      <span className="flex items-center justify-center leading-none">
        {icon}
      </span>
    </div>
  );
}

/* =========================================================
   ARROW
========================================================= */
function ArrowIcon() {
  return (
    <span
      className="
        flex
        h-5
        w-5
        shrink-0
        items-center
        justify-center
        text-[15px]
        font-bold
        leading-none
        text-slate-400
        transition-all
        duration-200
        group-hover:translate-x-0.5
        group-hover:text-cyan-600
      "
    >
      →
    </span>
  );
}

export default Sidebar;